import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import { API } from "../../API";
import { isAutheticated } from "../auth/authhelper";
import { useUser } from "../UserContext/UserProvider";

export default function Sidebar() {
  const { token, type, userdata } = isAutheticated();
  const { userData, adminLogo, loading } = useUser();
  console.log(userData, adminLogo, loading)
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [contentOpen, setContentOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [commerceOpen, setCommerceOpen] = useState(false);
  const [analyticsOpen, setAnalyticsOpen] = useState(false);

  const [ordersOpen, setOrdersOpen] = useState(false);
  const [settingOpen, setSettingOpen] = useState(false);

  const [paymentOpen, setPaymentOpen] = useState(false);
  const [configureOpen, setConfigureOpen] = useState(false);
  const [logo, setLogo] = useState("");
  // const [userData, setUserData] = useState('');


  // useEffect(() => {
  //   const fetchData = () => {
  //     axios
  //       .get(`${API}/api/user`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       })
  //       .then((res) => {
  //         if (res.data.data.picture !== "") {
  //           // console.log('res.data.data', res.data.data)
  //           setUserData(res.data?.data)
  //           setLogo(res.data.data.picture);
  //         }
  //       });
  //   };

  //   fetchData();
  // }, [token]);
  const [AdminLogo, setAdminLogo] = useState("");

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(`${API}/api/config/`);
        console.log(response?.data)
        if (response.data.result[0]?.logo[0]?.Adminlogo) {

          setAdminLogo(response.data.result[0]?.logo[0]?.Adminlogo);
        }
      } catch (error) {
        console.error("Failed to fetch the Admin logo:", error);
      }
    };

    fetchLogo();
  }, []);
  const hasPermission = (perm) => {
    if (type === "admin") return true; // admin can see everything
    return userData?.permissions?.[perm] === true;
  };
  return (
    <div className="vertical-menu">
      <div className="navbar-brand-box text-center">
        <div className="">
          {AdminLogo ? (
            <img src={AdminLogo} alt="Admin Logo" width={200} />
          ) : (
            // <img src="/logo-for-website-white.png" alt="Default Logo" height="34" />
            <div><h1 className="text-white">SoComOTT</h1> </div>
          )}
        </div>
      </div>

      <Collapse in={sidebarOpen} dimension="width">
        <div data-simplebar className="sidebar-menu-scroll " id="sidebarOpen">
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li>
                {hasPermission("Dashboard") && (

                  <Link to="/dashboard">
                    <img alt="" src="/assets/images/icons/dashboard-icon.png" />
                    <span>Dashboard</span>
                  </Link>)}
              </li>
              <li>
                {hasPermission("Team") && (
                  <Link to="/SoCom_advisor">
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span>SoCom Advisors</span>

                  </Link>
                )}
              </li>
              <li>
                {hasPermission("NetworkChannels") && (

                  <Link to="/network_channels">
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span>Network Channels</span>

                  </Link>)}
              </li>

              <li>
                {hasPermission("Channel") && (

                  <Link to="/channels">
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span>Channels</span>

                  </Link>)}
              </li>
              <li>
                {hasPermission("Videos") && (

                  <Link to="/Videos">
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span>Videos</span>

                  </Link>)}
              </li>


              <li>
                {hasPermission("RegistrationFee") && (
                  <Link to="/registration_fees">
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span>Registration Fees</span>

                  </Link>
                )}
              </li>




              <li>
                {hasPermission("SubscriptionFree") && (
                  <Link to="/subscription_fees">
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span>Subscription Fees</span>

                  </Link>
                )}
              </li>


              <li>
                {hasPermission("Analytics") && (
                  <Link to="/video_popup_click_transactions">
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span className="text">Video Popup Click</span>
                    <p style={{ marginLeft: "2.5rem" }}>
                      Transactions
                    </p>
                  </Link>
                )}
              </li>
              <li>
                {hasPermission("SubscriptionFree") && (
                  <Link to="/video_popup_click_commissions">
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span className="text">Video Popup Click</span>
                    <p style={{ marginLeft: "2.5rem" }}>
                      Commissions
                    </p>
                  </Link>
                )}
              </li>

              <li>
                {hasPermission("Team") && (
                  <Link to="/team">
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span>Team</span>

                  </Link>
                )}
              </li>



              <li>
                {hasPermission("Help") && (
                  <Link to="/help">
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span>Help</span>

                  </Link>
                )}
              </li>

              <li>
                {hasPermission("Advertisements") && (
                  <Link to="/ad_video">
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span>Advertisements</span>

                  </Link>
                )}
              </li>


              {hasPermission("Analytics") || type === "admin" ? (
                <li>
                  <Link
                    to="#/"
                    className="has-arrow"
                    onClick={() => setAnalyticsOpen(!analyticsOpen)}
                    aria-controls="analyticsOpen"
                    aria-expanded={analyticsOpen}
                  >
                    <img alt="" src="/assets/images/icons/cms-icon.png" />
                    <span>Analytics</span>
                  </Link>
                  <Collapse className="sub-menu" in={analyticsOpen}>
                    <ul id="analyticsOpen">
                      <li>
                        <Link to="/top-activity">Most Visited & Top Search Pages</Link>
                      </li>
                      <li>
                        <Link to="/user-activity">User Activity & Daily Unique Visitors</Link>
                      </li>
                      <li>
                        <Link to="/device-analytics">Browser & Device Usage</Link>
                      </li>
                      <li>
                        <Link to="/geo-analytics">Visitors by Country</Link>
                      </li>
                      <li>
                        <Link to="/bandwidth-consumption">Bandwidth consumption</Link>
                      </li>
                      <li>
                        <Link to="/watch_time">Watch Overview</Link>
                      </li>
                      {/* <li>
                        <Link to="/click_to_Buy">Click to Buy</Link>
                      </li> */}
                    </ul>
                  </Collapse>
                </li>
              ) : null}



              <li>
                {(hasPermission("Setting") || type === "admin") ? (
                  <>
                    <Link
                      to="#/"
                      className="has-arrow"
                      onClick={() => setSettingOpen(!settingOpen)}
                      aria-controls="settingOpen"
                      aria-expanded={settingOpen}
                    >
                      <img alt="" src="/assets/images/icons/cms-icon.png" />
                      <span>Settings</span>
                    </Link>
                    <Collapse className="sub-menu" in={settingOpen}>
                      <ul id="settingOpen">
                        <li>
                          <Link to="/subjects">Banners</Link>
                        </li>
                        <li>
                          <Link to="/business_name">Business Name</Link>
                        </li>
                        <li>
                          <Link to="/logo/">Logo</Link>
                        </li>
                        {/* Add other settings subsections here */}
                      </ul>
                    </Collapse>
                  </>
                ) : null}
              </li>


















              {/* {((type === "staff" && userdata.permissions.find((e) => e === "Subscribers")) ||
                type === "admin") && (
                  <li>
                    <Link to="/subscribers">
                      <img alt="" src="/assets/images/icons/viewer-icon.png" />
                      <span>Subscribers</span>
                    </Link>
                  </li>
                )} */}
              {/* {((hasPermission("Analytics") &&
                userdata.permissions.find(
                  (e) =>
                    e === "Analytics" ||
                    e === "Most Visited Pages" ||
                    e === "User Activity Over Time" ||
                    e === "User Activity & Daily Unique Visitors" ||
                    e === "Visitors by Country" ||
                    e === "Bandwidth consumption" ||

                    e === "Watch Overview"

                )) ||
                type === "admin") && (
                  <li>
                    <Link
                      to="#/"
                      className="has-arrow"
                      onClick={() => setAnalyticsOpen(!analyticsOpen)}
                      aria-controls="analyticsOpen"
                      aria-expanded={analyticsOpen}
                    >
                      <img alt="" src="/assets/images/icons/cms-icon.png" />
                      <span>Analytics</span>
                    </Link>
                    <Collapse className="sub-menu" in={analyticsOpen}>
                      <ul id="analyticsOpen">
                        {((type === "staff" &&
                          userdata.permissions.find((e) => e === "Products")) ||
                          type === "admin") && (
                            <li>
                              <Link to="/top-activity">Most Visited & Top Search Pages</Link>
                            </li>
                          )}

                        {((type === "staff" &&
                          userdata.permissions.find((e) => e === "Category")) ||
                          type === "admin") && (
                            <li>
                              <Link to="/user-activity"> User Activity & Daily Unique Visitors</Link>
                            </li>
                          )}

                        {((type === "staff" &&
                          userdata.permissions.find((e) => e === "ShopBanner")) ||
                          type === "admin") && (
                            <li>
                              <Link to="/device-analytics">Browser & Device Usage</Link>
                            </li>
                          )}
                        {((type === "staff" &&
                          userdata.permissions.find((e) => e === "Shipping")) ||
                          type === "admin") && (
                            <li>
                              <Link to="/geo-analytics"> Visitors by Country</Link>
                            </li>
                          )}
                        {((type === "staff" &&
                          userdata.permissions.find((e) => e === "Shipping")) ||
                          type === "admin") && (
                            <li>
                              <Link to="/bandwidth-consumption">Bandwidth consumption</Link>
                            </li>
                          )}
                        {((type === "staff" &&
                          userdata.permissions.find((e) => e === "Shipping")) ||
                          type === "admin") && (
                            <li>
                              <Link to="/watch_time">Watch Overview</Link>
                            </li>
                          )}

                      </ul>
                    </Collapse>
                  </li>
                )} */}
              {/* {((type === "staff" &&
                userdata.permissions.find(
                  (e) =>
                    e === "Videos" ||
                    e === "Advertisemets" ||
                    e === "Schedule" ||
                    e === "Banners"
                )) ||
                type === "admin") && (
                  <li>
                    <Link
                      to="#"
                      className="has-arrow"
                      onClick={() => setContentOpen(!contentOpen)}
                      aria-controls="contentOpen"
                      aria-expanded={contentOpen}
                    >
                      <img alt="" src="/assets/images/icons/cms-icon.png" />
                      <span>Content Management</span>
                    </Link>

                    <Collapse className="sub-menu" in={contentOpen}>
                    <ul id="contentOpen">
                      {((type === "staff" &&
                        userdata.permissions.find((e) => e === "Videos")) ||
                        type === "admin") && (
                          <li>
                            <Link to="/lessions">Videos</Link>
                          </li>
                        )}
                      {((type === "staff" &&
                        userdata.permissions.find((e) => e === "Advertisemets")) ||
                        type === "admin") && (
                          <li>
                            <img alt="" src="/assets/images/icons/cms-icon.png" />

                            <Link to="/adlessions">Advertisements</Link>
                          </li>
                        )}
                      

                      <li>
                        <Link to="/channels">Channels</Link>
                      </li>
                    </ul>
                    </Collapse>
                  </li>
                )} */}


              {/* {((type === "staff" &&
                userdata.permissions.find((e) => e === "Schedule")) ||
                type === "admin") && (
                  <li>
                    <Link to="/scheduleVideos">Schedule</Link>
                  </li>
                )} */}


              {/* product Start */}
              {((type === "staff" &&
                userdata.permissions.find(
                  (e) =>
                    e === "Products" ||
                    e === "Featured Products" ||
                    e === "Product Channel" ||
                    e === "Coupons" ||
                    e === "Shipping"
                )) ||
                type === "admin") && (
                  <li>
                    <Link
                      to="#/"
                      className="has-arrow"
                      onClick={() => setCommerceOpen(!commerceOpen)}
                      aria-controls="commerceOpen"
                      aria-expanded={commerceOpen}
                    >
                      <img alt="" src="/assets/images/icons/cms-icon.png" />
                      <span>OTT Shop</span>
                    </Link>
                    <Collapse className="sub-menu" in={commerceOpen}>
                      <ul id="commerceOpen">
                        {((type === "staff" &&
                          userdata.permissions.find((e) => e === "Products")) ||
                          type === "admin") && (
                            <li>
                              <Link to="/comproducts">Products</Link>
                            </li>
                          )}
                        {/* {((type === "staff" &&
                          userdata.permissions.find(
                            (e) => e === "Featured Products"
                          )) ||
                          type === "admin") && (
                            <li>
                              <Link to="/featured/products">Featured Products</Link>
                            </li>
                          )} */}
                        {((type === "staff" &&
                          userdata.permissions.find((e) => e === "Category")) ||
                          type === "admin") && (
                            <li>
                              <Link to="/comcatagory"> Category</Link>
                            </li>
                          )}
                        {/* {((type === "staff" &&
                          userdata.permissions.find((e) => e === "Coupons")) ||
                          type === "admin") && (
                            <li>
                              <Link to="/allCoupons">Coupons</Link>
                            </li>
                          )} */}
                        {/* {((type === "staff" &&
                          userdata.permissions.find((e) => e === "ShopBanner")) ||
                          type === "admin") && (
                            <li>
                              <Link to="/shop_banner"> Banners</Link>
                            </li>
                          )} */}
                        {/* {((type === "staff" &&
                          userdata.permissions.find((e) => e === "Shipping")) ||
                          type === "admin") && (
                            <li>
                              <Link to="/allShippings">Shipping</Link>
                            </li>
                          )} */}
                      </ul>
                    </Collapse>
                  </li>
                )}

              {/* {((type === "staff" &&
                userdata.permissions.find(
                  (e) =>
                    e === "ReportSubscribers" ||
                    e === "ReportEarnings" ||
                    e === "ReportMostWatched" ||
                    e === "ReportViewers"
                )) ||
                type === "admin") && (
                  <li>
                    <Link
                      to="#"
                      className="has-arrow"
                      onClick={() => setReportOpen(!reportOpen)}
                      aria-controls="reportOpen"
                      aria-expanded={reportOpen}
                    >
                      <img alt="" src="/assets/images/icons/cms-icon.png" />
                      <span>Reports</span>
                    </Link>

                    <Collapse className="sub-menu" in={reportOpen}>
                      <ul id="contentOpen">
                        {((type === "staff" &&
                          userdata.permissions.find(
                            (e) => e === "ReportSubscribers"
                          )) ||
                          type === "admin") && (
                            <li>
                              <Link to="/report/subscribers">Subscribers</Link>
                            </li>
                          )}
                        {((type === "staff" &&
                          userdata.permissions.find(
                            (e) => e === "ReportEarnings"
                          )) ||
                          type === "admin") && (
                            <li>
                              <Link to="/report/earnings">Earnings</Link>
                            </li>
                          )}
                        {((type === "staff" &&
                          userdata.permissions.find(
                            (e) => e === "ReportVideos"
                          )) ||
                          type === "admin") && (
                            <li>
                              <Link to="/report/videos">Videos</Link>
                            </li>
                          )}
                      </ul>
                    </Collapse>
                  </li>
                )} */}
              {/* product End */}

              {/* Order Management */}

              <li>
                {/* <Link
                  to="#/"
                  className="has-arrow"
                  onClick={() => setOrdersOpen(!ordersOpen)}
                  aria-controls="ordersOpen"
                  aria-expanded={ordersOpen}
                >
                  <img alt="" src="/assets/images/icons/revenue-icon.png" />
                  <span>Orders Management</span>
                </Link> */}
                <Collapse className="sub-menu" in={ordersOpen}>
                  <ul id="ordersOpen">
                    <li>
                      <Link to="/orders/new">New</Link>
                    </li>
                    {/* <li>
                      <Link to="/orders/processing">Processing</Link>
                    </li>
                    <li>
                      <Link to="/orders/dispatched">Dispatched</Link>
                    </li>
                    <li>
                      <Link to="/orders/delivered">Delivered</Link>
                    </li>
                    <li>
                      <Link to="/orders/cancelled">Cancelled</Link>
                    </li>
                    <li>
                      <Link to="/orders/returned">Returned</Link>
                    </li> */}
                  </ul>
                </Collapse>
              </li>
              {/* Order Management End */}

              {/* Revenvue */}
              {/* {((type === "staff" &&
                userdata.permissions.find((e) => e === "Earnings")) ||
                type === "admin") && (
                  <li>
                    <Link to="/revenue">
                      <img alt="" src="/assets/images/icons/revenue-icon.png" />
                      <span>Earnings</span>
                    </Link>
                  </li>
                )} */}
              {/* Revenvue End


              {/* <li>
                <Link
                  to="#/"
                  className="has-arrow"
                  onClick={() => setSettingOpen(!settingOpen)}
                  aria-controls="settingOpen"
                  aria-expanded={settingOpen}
                >
                  <img alt="" src="/assets/images/icons/cms-icon.png" />
                  <span>Settings</span>
                </Link>
                <Collapse className="sub-menu" in={settingOpen}>
                  <ul id="settingOpen"> */}
              {/* <li>
                      <Link to="/subscription_types">Subscription Type</Link>
                    </li> */}
              {/* {((type === "staff" &&
                      userdata.permissions.find((e) => e === "Banners")) ||
                      type === "admin") && (
                        <li>
                          <Link to="/subjects">Banners</Link>
                        </li>
                      )} */}
              {/* <li>
                      <Link to="/currency">Currency</Link>
                    </li> */}


              {/* <li>
                      <Link to="/configuration/profile"> Profile</Link>
                    </li>

                    <li>
                      <Link to="/configuration/text">Text</Link>
                    </li>
                    <li>
                      <Link to="/configuration/address">Address</Link>
                    </li>
                    <li>
                      <Link to="/configuration/address">Address</Link>
                    </li>

                    <li>
                      <Link to="/configuration/social-media">Application Name</Link>
                    </li> */}
              {/* <li>
                      <Link to="/business_name">Business Name</Link>
                    </li>
                    <li>
                      <Link to="/logo/">logo</Link>
                    </li> */}
              {/* <li>
                      <Link to="/tax-rates">Tax</Link>
                    </li> */}
              {/* <li>
                      <Link to="/orders/cancelled">Legal Page</Link>
                    </li>
                    <li>
                      <Link to="/orders/returned">Logos</Link>
                    </li>
                    <li>
                      <Link to="/orders/returned">Social Media</Link>
                    </li>
                    <li>
                      <Link to="/orders/returned">Google Analytics</Link>
                    </li>
                    <li>
                      <Link to="/orders/returned">Copyright Message</Link>
                    </li> */}
              {/* </ul>
                </Collapse>
              </li> */}
            </ul>
          </div>
        </div>
      </Collapse>
    </div>
  );
}
